import { RoleEnum, SupportService } from '@acme/api/client';
import { UserStatusEnum, useUser } from '@acme/domains';
import { HelpSection, Sidebar, SupportChat } from '@acme/features';
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BalanceWidget } from '@acme/features/features';
import { AppRoutes } from '../../shared/routes';

interface LayerProps {
  children: React.ReactNode;
}

export function DefaultLayout({ children }: LayerProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, organization, isLoading, logout } = useUser();

  const handleCreateApplication = () => {
    navigate('/application/create');
  };

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  const isSidebarDisabled =
    user?.status === UserStatusEnum.ExpectsChanges ||
    user?.status === UserStatusEnum.AwaitingСonfirmation;

  return (
    <div className="bg-gray-100 flex h-screen overflow-hidden">
      <Sidebar
        navigationItems={[
          {
            label: 'Главная',
            iconName: 'home-outline',
            path: '/dashboard',
          },

          {
            label: 'Курсы обмена',
            iconName: 'cash-outline',
            path: '/rates',
          },
          {
            label: 'Документы',
            iconName: 'file-lines-outline',
            path: '/documents',
          },
        ]}
        className="h-screen flex-shrink-0"
        onCreateApplication={handleCreateApplication}
        disabled={isSidebarDisabled}
        organization={organization}
        user={user}
        isLoading={isLoading}
        onLogout={logout}
        currentPath={location.pathname}
        onNavigate={handleNavigate}
      >
        {organization?.role?.id !== RoleEnum.Admin && (
          <>
            <Link to={AppRoutes.balance.getPath?.() as string}>
              <BalanceWidget />
            </Link>

            <HelpSection helpLinkPath="/help">
              <SupportChat
                companionLabelText="Оператор поддержки"
                sendMessage={SupportService.postApiV1SupportMessageSend}
                readMessages={SupportService.postApiV1SupportMessageRead}
                getAttachmentReq={
                  SupportService.getApiV1SupportMessageAttachment
                }
                loadChatHistory={SupportService.getApiV1SupportMessageList}
              />
            </HelpSection>
          </>
        )}
      </Sidebar>

      <main className="flex-1 overflow-y-auto py-6 px-8">{children}</main>
    </div>
  );
}
